import React from "react";
import styled from "styled-components";
import { fonts } from "./mixins";
import { TooltipInfoIcon } from "../icons/TooltipInfoIcon";
import { BREAKPOINT_RESERVATION_PAGE } from "../../pageComponents/reservationPage/constants/breakpoints";

const Wrapper = styled.div`
  position: relative;
  display: inline-flex;

  &:hover > div {
    display: flex;
  }
`;

const Box = styled.div<{ $shiftOnMobile: boolean }>`
  display: none;
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: 220px;
  padding: 8px;
  border-radius: 8px;
  border: 1px solid #edf1f6;
  background: #fff;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.08);
  ${fonts.normalTextSmall()}
  z-index: 10;

  @media (max-width: ${BREAKPOINT_RESERVATION_PAGE}) {
    ${({ $shiftOnMobile }) => $shiftOnMobile && "left: -200px;"}
  }
`;

interface TooltipProps {
  text: string;
  // Pulls the box back from the icon on narrow screens. Set it where the icon
  // trails a long heading and so sits near the right edge — anchored at left: 0
  // the 220px box would run off the viewport there.
  shiftOnMobile?: boolean;
}

export function Tooltip({ text, shiftOnMobile = false }: TooltipProps) {
  return (
    <Wrapper>
      <TooltipInfoIcon color="#646567" />
      <Box $shiftOnMobile={shiftOnMobile}>{text}</Box>
    </Wrapper>
  );
}
